import {
  SET_TIPOS_GRUPO_PLANES,
  SET_TIPOS_PUBLICACION,
  FETCH_TIPOS_PUBLICACION,
  FETCH_TIPOS_PUBLICACION_BYID,
  LOADING_TIPOS_PUBLICACION,
  RESET_FILTRO_TIPOS_PUBLICACION,
  SET_FILTRO_TIPOS_PUBLICACION,
  RESET_TIPOS_PUBLICACION,
  RESET_VALUE_CHECKED,
  RESET_SET_TIPO_PUBLICACIONES,
  UPDATE_LIST_TIPOS_PUBLICACIONES,
  IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB
} from './types';
import { getTiposPublicacion, fetchTipoPublicacionApi, getGrupoPlanes } from '../api/axios';

const normalizeTiposPublicacionResponse = (response) => {
  const data = response?.data ?? response ?? {};

  const elementos =
    Array.isArray(data?.elementos) ? data.elementos :
      Array.isArray(data?.Elementos) ? data.Elementos :
        Array.isArray(data?.content) ? data.content :
          Array.isArray(data?.Content) ? data.Content :
            Array.isArray(data?.paginationTiposPublicacion?.content) ? data.paginationTiposPublicacion.content :
              Array.isArray(data?.paginationTiposPublicacion?.Content) ? data.paginationTiposPublicacion.Content :
                [];

  const normalizedElementos = elementos.map((item) => ({
    ...item,
    idTipoPublicacion: item?.idTipoPublicacion ?? item?.IdTipoPublicacion ?? null,
    codigo: item?.codigo ?? item?.Codigo ?? item?.idTipoPublicacion ?? item?.IdTipoPublicacion ?? 0,
    descripcion: item?.descripcion ?? item?.Descripcion ?? "",
    comision: item?.comision ?? item?.Comision ?? 0,
    cantidadGrupoPlanes: item?.cantidadGrupoPlanes ?? item?.CantidadGrupoPlanes ?? 0,
    cantidadPublicaciones: item?.cantidadPublicaciones ?? item?.CantidadPublicaciones ?? 0,
    estado: item?.estado ?? item?.Estado ?? 0,
    cantidadCuotas: item?.cantidadCuotas ?? item?.CantidadCuotas ?? 0,
    grupoPlanes: Array.isArray(item?.grupoPlanes) ? item.grupoPlanes :
      Array.isArray(item?.GrupoPlanes) ? item.GrupoPlanes : []
  }));

  const total =
    data?.total ?? data?.Total ??
    data?.cantidadTotal ?? data?.CantidadTotal ??
    data?.paginationTiposPublicacion?.total ?? data?.paginationTiposPublicacion?.Total ??
    elementos.length;

  const page =
    data?.page ?? data?.Page ??
    data?.numeroPagina ?? data?.NumeroPagina ??
    data?.paginationTiposPublicacion?.page ?? data?.paginationTiposPublicacion?.Page ?? 1;

  return {
    data: {
      elementos: normalizedElementos,
      total,
      page
    }
  };
};


export const fetchTiposPublicacion = (idSeller) => async dispatch => {
  const id = idSeller != null && idSeller !== '' ? parseInt(idSeller, 10) : NaN;
  if (!Number.isFinite(id) || id <= 0) {
    return;
  }
  const req = fetchTipoPublicacionApi(id);
  req.then((tipos) => {

    dispatch({
      type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
      payload: true
    });

    const raw =
      tipos?.tiposPublicaciones ??
      tipos?.TiposPublicaciones ??
      tipos?.elementos ??
      tipos?.Elementos;
    const list = Array.isArray(raw) ? raw : [];

    dispatch({
      type: SET_TIPOS_PUBLICACION,
      payload: list
    });
  }).catch((error) => {
    console.error("Error fetching tipos publicacion:", error);
    dispatch({
      type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
      payload: true // Stop loading logic if any
    });
  })
}

export const setTiposPublicacion = (params) => async dispatch => {

  dispatch({
    type: SET_TIPOS_PUBLICACION,
    payload: params,
  });
}

export const resetSetTiposPublicaciones = (object) => async dispatch => {
  dispatch({
    type: RESET_SET_TIPO_PUBLICACIONES,
    payload: object
  })
}

export const resetValueChecked = () => async dispatch => {
  dispatch({
    type: RESET_VALUE_CHECKED,
    payload: [],
  });
}

export const setFiltroTipoPublicaciones = () => async dispatch => {

  dispatch({
    type: SET_FILTRO_TIPOS_PUBLICACION,
    payload: [],
  });
}

export const resetTipoPublicaciones = () => async dispatch => {

  dispatch({
    type: RESET_TIPOS_PUBLICACION,
    payload: [],
  });
}



export const setTiposGrupoPlanes = (params) => async dispatch => {

  dispatch({
    type: SET_TIPOS_GRUPO_PLANES,
    payload: params,
  });
}
export const setFiltroTiposPublicacion = (filtro) => async dispatch => {
  dispatch({
    type: SET_FILTRO_TIPOS_PUBLICACION,
    payload: filtro,
  });
}

export const resetTiposPublicacion = (filtro) => async dispatch => {
  dispatch({
    type: RESET_FILTRO_TIPOS_PUBLICACION,
    payload: filtro,
  });
}

export const fetchTiposPublicacionAdm = (request) => async dispatch => {
  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });

  try {
    const response = await getTiposPublicacion(request);
    const normalized = normalizeTiposPublicacionResponse(response);
    dispatch({
      type: FETCH_TIPOS_PUBLICACION,
      payload: normalized
    });
    return normalized;
  } catch (error) {
    dispatch({
      type: FETCH_TIPOS_PUBLICACION,
      payload: { data: { elementos: [], total: 0, page: 1 } }
    });
  } finally {
    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });
  }
}


export const fetchTiposPublicacionAdmById = (request) => async dispatch => {
  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });

  try {
    const value = await getTiposPublicacion(request);
    dispatch({
      type: FETCH_TIPOS_PUBLICACION_BYID,
      payload: value
    });
  } catch (e) {
    dispatch({
      type: FETCH_TIPOS_PUBLICACION_BYID,
      payload: { data: {} }
    });
  } finally {
    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });
  }
}


export const fetchTiposGrupoPlanesByTipoId = (idTipoPublicacion) => async dispatch => {
  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });
  // Assuming getGrupoPlanes supports ID filter via request params or similar
  // Based on search request model: public int? IdTipoPublicacion { get; set; }
  let request = {
    IdTipoPublicacion: idTipoPublicacion,
    Page: 1,
    PageSize: 100 // Fetch a reasonable amount
  };

  let array = getGrupoPlanes(request);
  array.then((value) => {

    const data = value.data;
    let normalized = [];

    if (data?.paginationGrupoPlanes) {
      const pag = data.paginationGrupoPlanes;
      normalized = pag.content || pag.Content || [];
    } else if (data?.elementos) {
      normalized = data.elementos;
    }

    dispatch({
      type: SET_TIPOS_GRUPO_PLANES,
      payload: normalized
    });

    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });
  }).catch(err => {
    dispatch({
      type: SET_TIPOS_GRUPO_PLANES,
      payload: []
    });
    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });
  })
}

export const updateListTiposPublicaciones = (tiposPublicacionesArray, tipoPublicacion) => async dispatch => {
  // Transformar `tipoPublicacion` para que `idTipoPublicacion` sea `codigo` y elimino idTipoPublicacion
  const tipoPublicacionTransformada = {
    ...tipoPublicacion,
    codigo: tipoPublicacion.idTipoPublicacion,
  };
  delete tipoPublicacionTransformada.idTipoPublicacion;

  //existe un elemento que cumpla con las condiciones
  const existe = tiposPublicacionesArray.elementos.some(item =>
    item.codigo === tipoPublicacionTransformada.codigo &&
    (item.descripcion !== tipoPublicacionTransformada.descripcion
      || item.comision !== tipoPublicacionTransformada.comision
      || item.cantidadCuotas !== tipoPublicacionTransformada.cantidadCuotas
    )
  );

  if (!existe) {
    return;
  }

  // Crear nuevo array actualizando el elemento correspondiente
  const elementosActualizados = tiposPublicacionesArray.elementos.map(item =>
    item.codigo === tipoPublicacionTransformada.codigo ? { ...item, ...tipoPublicacionTransformada } : item
  );

  // Crear una nueva copia del objeto Array con los elementos actualizados
  const updatedTiposPublicacionesArray = {
    ...tiposPublicacionesArray,
    elementos: elementosActualizados,
  };

  dispatch({
    type: UPDATE_LIST_TIPOS_PUBLICACIONES,
    payload: updatedTiposPublicacionesArray
  });
};